export default __webpack_public_path__ + "95ac8d03a20776c7b059d01ddc973020.png";